import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()

export class MomentService {
    constructor() { }

    // Get a moment for a given date.
    getMoment(date: string | Date | firebase.firestore.Timestamp | any): moment.Moment {
        // Check if date is a string.
        if (typeof date === 'string') {
            return this.getMomentFromDateString(date);
        }

        // Check if date is a Date
        if (date instanceof Date) {
            return moment(date);
        }

        // Might be a timestamp?
        if (date && date.toDate) {
            return moment(date.toDate());
        }

        // Last, check for seconds/nanoseconds on obj, a stringified and unstringified timestamp will lose toDate() function.
        if (date && date.seconds) {
            let seconds = date.seconds || 0;
            let nanoseconds = date.nanoseconds || 0;
            return moment((seconds * 1000) + (nanoseconds / 1000000));
        }

        // The seconds prop could be _seconds as well...
        if (date && date._seconds) {
            let seconds = date._seconds || 0;
            let nanoseconds = date._nanoseconds || 0;
            return moment((seconds * 1000) + (nanoseconds / 1000000));
        }
        
        // If it makes hit here just return a timestamp.
        return moment();
    }

    getMomentFromDateString(dateString: string): moment.Moment {
        //let thisMoment: moment.Moment = null;
        try {
            if(dateString.indexOf("T") > -1) {
                return moment(dateString);
            }
            else if(dateString && dateString.indexOf("/") > -1) {
                let dateParts: string[] = dateString.split("/");
                let month = parseInt(dateParts[0]);
                let day = parseInt(dateParts[1]);
                let year = parseInt(dateParts[2]);
                return moment(new Date(year, month-1, day));
            }
            else if(dateString && dateString.indexOf("-") > -1) {
                let dateParts: string[] = dateString.split("-");
                let month = parseInt(dateParts[0]);
                let day = parseInt(dateParts[1]);
                let year = parseInt(dateParts[2]);
                return moment(new Date(year, month-1, day));
            }
            else {
                return moment(dateString)
            }
            //console.log(thisMoment.format("MM-DD-YYYY"))
            //return thisMoment;
        }
        catch(e) {
            console.error(e);
            return moment();
        }
    }
}